import React from "react";
import { language } from "language/default";
export const InsDefaultError = () => React.createElement(React.Fragment, null, language.en.widget.errorWidgetTitle);
